module.exports = __webpack_public_path__ + "img/company-management.9c5bea83.png";